import React from 'react';
import TitledBox from '../../titled_box/titled_box';
import COLORS from '../../../theme/colors';

import './info_section.scss';

export default function InfoSection() {
  const icon = (name) => {
    return <div className={`icon icon-${name}`} />;
  };
  const emoji = (name) => {
    return <div className={`emoji emoji-${name}`} />;
  };

  return (
    <div className="info-section">
      <TitledBox
        title="WHY TEAMHUB?"
        titleIcon={icon('newspaper')}
        content={
          <div>
            Take your Slack further and engage people even offline.
            <br />
            {"Let everyone see what's important to you and your team on the office TVs."}
          </div>
        }
        color={COLORS.turquoise}
      />
      <TitledBox
        title="HOW IT WORKS?"
        titleIcon={icon('message')}
        content={
          <div>
            When people react to a message, it gets on the big screen!
            <br />
            {"You see what's trending, even if it is not in your channel."}
          </div>
        }
        color={COLORS.pink}
      />
      <TitledBox
        title="YOU HAVE CONTROL"
        titleIcon={icon('cactus')}
        content={
          <div>
            Want to feature an important Slack message?
            <br />
            <span>
              Just put a {emoji('newspaper')} on it! Something not ok for the TV? Add a {emoji('cactus')}
            </span>
          </div>
        }
        color={COLORS.purple}
      />
      <TitledBox
        title="WEBEX"
        titleIcon={icon('webex')}
        content={
          <div>
            Are you a Webex user?
            Share your news on the TV by just adding #news to your Webex message.
          </div>
        }
        color={COLORS.blue}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/landing/info_section/info_section.jsx